export default __webpack_public_path__ + "static/media/2267_closed.92eca34a.jpg";